import { Container } from "../LeftAsideStyled";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { useAppSelector } from "redux/hooks";
import { Text } from "components/atoms/text/Text";
import { calcRem } from "styles/theme";
import { useMemo, useState } from "react";

import WebAppLink from "components/blocks/link/WebAppLink";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import Type from "components/atoms/text/labels/Type";
import RecorderDetailAlert from "./RecorderDetailAlert";
import RecorderDetailSystem from "./RecorderDetailSystem";
import * as AlertViewStyled from "pages/alert/view/AlertViewStyled";
import {
  AlertViewAccountInfo,
  AlertViewInfo,
} from "api/interfaces/alertInterface.interface";
import X from "assets/icons/x_map.svg";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { convertType } from "utils/functions";
import * as mediaQuery from "components/MediaQuery";
import Tabs from "components/atoms/tabs/Tabs";
import useAccountAccess from "hook/useAccountAccess";
type DualProps = {
  selectedAlert: AlertViewInfo;
  isViewRecorderList: boolean;
  onModal: () => void;
  cloudStatus: boolean;
};

export const enum RECORDER_DETAIL_MENU {
  ALERT = "Alert",
  SYSTEM = "System",
}

export const RecorderDetailMenu = [
  {
    label: "Alert",
    value: RECORDER_DETAIL_MENU.ALERT,
  },
  {
    label: "System",
    value: RECORDER_DETAIL_MENU.SYSTEM,
  },
];

const RecorderDetailView = (props: DualProps): JSX.Element => {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [currentMenu, setCurrentMenu] = useState<RECORDER_DETAIL_MENU>(
    RECORDER_DETAIL_MENU.ALERT
  );
  const [accountInfo, setAccountInfo] = useState<AlertViewAccountInfo[]>([]);

  const recorderAccounts = useMemo(() => {
    return (accountInfo || []).sort((a, b) =>
      a.level === LEVEL_TYPE.EU ? 1 : a.level === LEVEL_TYPE.CP ? -1 : 0
    );
  }, [accountInfo]);
  const { AccountAccessButton, AccountAccessModal } = useAccountAccess({
    buttonType: "RecorderAccountButton",
    useTemporary: false,
    isShowOnlyUser: true,
    toPath: "/recorders/list",
  });

  return (
    <Wrapper isViewRecorderList={props.isViewRecorderList}>
      <ViewContainer>
        <Header>
          <AlertViewStyled.CloseButton
            onClick={props.onModal}
            className="close-button"
            data-testid="dashboard-map-detail-close-button-modal"
          >
            <img alt="close button" src={X} />
          </AlertViewStyled.CloseButton>
          <AlertViewStyled.HeaderInner>
            <Title>
              {recorderAccounts.length > 0 && (
                <AlertViewStyled.AccountInfoListWrapper>
                  {recorderAccounts.map((account, index) => (
                    <AccountAccessButton
                      accountId={account.accountId}
                      key={account.accountId}
                      accountName={account.accountName}
                      accountNumber={account.accountNumber}
                      level={account.level}
                      index={index}
                    />
                  ))}
                </AlertViewStyled.AccountInfoListWrapper>
              )}

              <AlertViewStyled.HeaderSub isModal={true}>
                <Type
                  type={convertType(props.selectedAlert)}
                  licenseType={props.selectedAlert.licenseType}
                  isCloudCam={props.selectedAlert.isCloudCam}
                />

                {/* <div className="title-wrapper"> */}
                <div className="system-title">
                  <Text bold className="system-name">
                    {props.selectedAlert.mergedSystemName !== undefined
                      ? props.selectedAlert.mergedSystemName
                      : props.selectedAlert.recorderName}
                  </Text>
                  {props.selectedAlert.type === "Spectrum" && (
                    <Text fontSize={14} color="#828B9B" className="server-name">
                      {props.selectedAlert.recorderName}
                    </Text>
                  )}
                </div>
                <div className="web-app-link-wrapper">
                  <WebAppLink
                    {...props.selectedAlert}
                    displayType={convertType(props.selectedAlert)}
                    accountId={selectedAccount.accountId}
                    cloudStatus={props.cloudStatus}
                  />
                </div>
                {/* </div> */}
              </AlertViewStyled.HeaderSub>
              {props.selectedAlert.location && (
                <span className="location">{props.selectedAlert.location}</span>
              )}
            </Title>
          </AlertViewStyled.HeaderInner>
        </Header>

        {selectedAccount.isEnabled && (
          <Tabs
            tabs={RecorderDetailMenu}
            currentTab={currentMenu}
            onChangeTab={(value: string) =>
              setCurrentMenu(value as RECORDER_DETAIL_MENU)
            }
          />
        )}

        <Inner>
          {currentMenu === RECORDER_DETAIL_MENU.ALERT && (
            <RecorderDetailAlert
              selectedAlert={props.selectedAlert}
              setAccountInfo={setAccountInfo}
            />
          )}

          {currentMenu === RECORDER_DETAIL_MENU.SYSTEM && (
            <RecorderDetailSystem
              type={props.selectedAlert.type}
              recorderId={props.selectedAlert.recorderId}
              brand={props.selectedAlert.brand}
            />
          )}

          {/* {currentMenu === 2 && <RecorderDetailCamera />} */}
        </Inner>
      </ViewContainer>
      {AccountAccessModal}
    </Wrapper>
  );
};

export default RecorderDetailView;

const Wrapper = styled.div<{ isViewRecorderList: boolean }>`
  height: 100%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  position: absolute;
  top: 0;
  z-index: 667;

  ${mediaQuery.isDefault} {
    width: 480px;
    ${({ isViewRecorderList }) =>
      isViewRecorderList
        ? `
        left: 265px;

        `
        : `
        left: 10px;
        
     `}
  }

  .close-button {
    top: 10px;
    right: 10px;

    > img {
      width: 15px;
    }

    ${mediaQuery.isMobile} {
      top: 5px;

      > img {
        width: 10px;
      }
    }
  }

  .modal-submenu {
    padding-top: 0;
  }
  ${mediaQuery.isMobile} {
    width: 100%;
  }
`;

const Header = styled.header`
  width: 100%;

  ${mediaQuery.isMobile} {
    padding: 10px;
  }
`;

const ViewContainer = styled(Container)`
  border-radius: 6px;
  height: 100%;
  /* height: calc(100% - 20px); */
  .tab {
    width: 100%;
  }

  .modal-sub-menu-li {
    flex: 1;
    text-align: center;
    font-size: ${calcRem(14)};
  }
`;

const Title = styled.div`
  width: 100%;

  .location {
    color: ${COLORS.BUTTONS1};
    font-size: ${calcRem(13)};
    margin-top: 8px;
    display: inline-block;
  }
`;
const Inner = styled.div`
  width: 100%;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding-top: 15px;
`;
